exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".on-form-wrap{display:flex;flex-direction:column;grid-gap:25px;gap:25px}.on-form-wrap .child-input-wrapper{display:flex;flex-direction:column;grid-gap:0;gap:0}", ""]);
